import React, { Component } from 'react';
//import Slider from "react-slick";
import {data} from './data';
//import pin from "./assets/logo.png";
import headerImg from "./assets/logo.png";
import headerImgMob from "./assets/logo-mob.png";
import './App.css';

let mapZoom = 2.35;
let minZoom = 2.35;
let mapPointImage = "M 0, 0 m -9, 0 a 9,9 0 1,0 18,0 a 9,9 0 1,0 -18,0";
if(window.innerWidth < 768){
	mapZoom = 1.5;
	minZoom = 1.5;
	mapPointImage= "M 0, 0 m -5.5, 0 a 5.5,5.5 0 1,0 11,0 a 5.5,5.5 0 1,0 -11,0";
}

let pointEvent = 'mouseover';
let pointEvent2 = 'mouseout';
if(window.innerWidth < 1024){
	pointEvent = 'click';
	pointEvent2 = '';
}

class App extends Component {
	state = {
		activePopup: null,
		map: {
			center: {
				lat: 38.0397381,
				lng: 9.754568
			},
			styles: [{
				"elementType": "geometry",
				"stylers": [{
					"color": "#505050"
				}]
			}, {
				"elementType": "labels",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"elementType": "labels.icon",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "administrative",
				"elementType": "geometry",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "administrative.country",
				"elementType": "geometry.stroke",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "administrative.neighborhood",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "poi",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road",
				"elementType": "labels.icon",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "transit",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [{
					"color": "#333333"
				}]
			}],
			zoom: mapZoom,
			gmObject: null,
			animating: false,
			animatingTimer: null,
			onClickVisibleText: false,
		},
		data:  data
	}

	componentDidMount() {	
		this.initMap();	
	}

	initMap() {

		let map = new window.google.maps.Map(this.mapHolder, {
			scrollwheel: false,
			center: this.state.map.center,
			zoom: this.state.map.zoom,
			minZoom: minZoom,
			noWrap: true,
			continuousWorld: false,
			styles: this.state.map.styles,
			mapTypeControl: false,
			streetViewControl: false,
			zoomControlOptions: {
				position: window.google.maps.ControlPosition.RIGHT_CENTER
			},
			fullscreenControl: false
		});

		let newData = this.state.data.map((item, i) => {
			if (item.coords) {
				item.marker = this.createMarker(map, item, i);
			}
			return item;
		});

		this.setState({
			data: newData
		});
	}

	createMarker(map, data, i) {
		let pin = {
			path: mapPointImage,
			strokeWeight: 0,
			fillColor: data.pinColor,
			fillOpacity: 1,
			rotation: 0,
			scale: 1.0,
		}
		let lableNumber = data.rank < 11 ? data.rank : ' ';
		let markerIndex = i < 11 ? 100 : 1;
		
		let marker = new window.google.maps.Marker({
			position: {
				lat: data.coords[0],
				lng: data.coords[1]
			},
			map: map,
			icon: pin,
			label: {
				text: "" +lableNumber+ "",
				fontSize: "10px",
				fontFamily: "Open Sans"
			},
			zIndex: markerIndex,
		});

		marker.addListener(pointEvent, () => {
			this.setActivePopup(i);
		});
		marker.addListener(pointEvent2, () => {
			this.setActivePopup(null);
		});
	}

	setActivePopup(i) {
		// scroll to map
		if (i !== null) {
			//window.scrollTo(0, this.popup.getBoundingClientRect().top + window.scrollY - 300);
		}

		// update popup
		this.setState({
			activePopup: i
		});

	}

	render() {

		return (
			<React.Fragment>
				<div className="App">
					<header id="header">
						<div className="container">
							<img src={headerImg} alt="gap-your-destination" className="header-img" />
							<img src={headerImgMob} alt="gap-your-destination" className="header-img-mob"/>
							<div className="header-text">
								<p>
									{window.innerWidth > 768 ? "Ever wondered which destination around the world has the highest number of places to enjoy a refreshing beverage? Us too. Whether you want to party the night away during a long weekend break or relax with a glass of your favourite tipple in an exotic location, these are the cities to visit. Who will take the crown as the destination with the highest number of bars?" : "Ever wondered which destination around the world has the highest number of bars? Us too. Whether you want to party the night away or relax with your favourite tipple, these are the destinations to visit if you’re after a good time."}
								</p>
								<strong>{window.innerWidth > 1024 ? "" : "Tap each destination to ﬁnd out the number of bars in each location. "}</strong>
							</div>
						</div>
					</header>
					<main id="main">
						<div className="legend">
							<div className="container">
								<div className="legend-panel">
									<span>Least bars</span>
									<span>Most bars</span>
								</div>
								<strong>
									{window.innerWidth > 1024 ? "Hover over each destination to ﬁnd out the number of bars in each location. " : "Pich and zoom to explore the map."}
								</strong>
							</div>
						</div>
						<div className="map-holder">
							<div
								id="regions-map"
								className="map"
								ref={el => this.mapHolder = el}
							></div>
							<div className={'popup' + (this.state.activePopup || this.state.activePopup === 0 ? ' active' : '')} ref={el => this.popup = el}>
								{(this.state.activePopup || this.state.activePopup === 0) && (
								<React.Fragment>
									<div className="popup-cont">
										<p className="popup-rank">Rank: {this.state.data[this.state.activePopup].rank}</p>
										<strong className="popup-city">{this.state.data[this.state.activePopup].city}</strong>
										<p className="popup-country">{this.state.data[this.state.activePopup].country}</p>
										<strong className="popup-number">Number of bars: {this.state.data[this.state.activePopup].number}</strong>
										<span className="popup-close" onClick={() => this.setActivePopup(null)}></span>
									</div>
								</React.Fragment>
								)}
							</div>
						</div>
						<h3 className="cont-question">Where will your next tipple take you?</h3>
					</main>
				</div>
			</React.Fragment>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js